<script setup>
import { computed } from 'vue'

const props = defineProps({
  tier: {
    type: Number,
    required: true,
    validator: (value) => [0, 1, 2].includes(value)
  },
  size: {
    type: String,
    default: 'default',
    validator: (value) => ['small', 'default', 'large'].includes(value)
  }
})

const badgeText = computed(() => {
  if (props.tier === 1) return 'Sponsored Bronze'
  if (props.tier === 2) return 'Sponsored Gold'
  return ''
})

const badgeClasses = computed(() => {
  const baseClasses = 'inline-flex items-center justify-center font-semibold text-white rounded-full whitespace-nowrap'
  
  let sizeClasses = ''
  if (props.size === 'small') {
    sizeClasses = 'px-2 py-1 text-xs sm:text-xs'
  } else if (props.size === 'large') {
    sizeClasses = 'px-3 py-1.5 text-sm sm:px-4 sm:py-2 sm:text-base'
  } else {
    sizeClasses = 'px-2 py-1 text-xs sm:px-3 sm:py-1.5 sm:text-sm'
  }
  
  let tierClasses = ''
  if (props.tier === 1) {
    tierClasses = 'bg-amber-600 border border-amber-700 shadow-sm'
  } else if (props.tier === 2) {
    tierClasses = 'bg-yellow-500 border border-yellow-600 shadow-sm'
  }
  
  return `${baseClasses} ${sizeClasses} ${tierClasses}`
})
</script>

<template>
  <span v-if="tier > 0" :class="badgeClasses">
    {{ badgeText }}
  </span>
</template>